import { render } from "./twCurrencyInput.vue?vue&type=template&id=4c6ea14a"
import script from "./twCurrencyInput.vue?vue&type=script&lang=js"
export * from "./twCurrencyInput.vue?vue&type=script&lang=js"

import exportComponent from "/builds/weleaf/twd-origination-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QInput from 'quasar/src/components/input/QInput.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QInput});
